<template>
  <div class="terms-of-use">
    <h1>Terms of Use</h1>
    <p>
      These Terms of Use govern your use of our platform. By accessing our services, you agree to be bound by these terms.
    </p>
    <h2>Acceptance of Terms</h2>
    <p>
      By using our platform, you confirm that you have read, understood, and agreed to these Terms of Use.
    </p>
    <h2>Usage Guidelines</h2>
    <p>
      All users are expected to use the platform in a responsible manner. Any misuse may result in account suspension.
    </p>
    <h2>Limitation of Liability</h2>
    <p>
      We are not liable for any direct, indirect, incidental, or consequential damages arising from your use of our platform.
    </p>
    <h2>Changes to Terms</h2>
    <p>
      We reserve the right to modify these terms at any time. Changes will be communicated on this page.
    </p>
  </div>
</template>

<script>
export default {
  name: 'TermsOfUse'
};
</script>

<style scoped>
.terms-of-use {
  padding: 2rem;
  line-height: 1.6;
}
.terms-of-use h2 {
  margin-top: 1.5rem;
}
</style>
